import React from "react"
import "./Header.css"
import { Link } from "gatsby"
import "./Icon.css"
import logo from "../../images/masu-header2.svg"

const Header = props => {
  return (
    <header
      className={`header ${props.navOpen ? "header_open" : "header_close"}`}
    >
      <Link className={"header_img"} to="/">
        <img src={logo} alt="masu logo" />
      </Link>
      <div className={"icon"} onClick={() => props.toggleNav()}>
        <span className={`${props.navOpen ? "rot_one" : "line1"}`} />
        <span className={`${props.navOpen ? "rot_two" : "line2"}`} />
        <span className={`${props.navOpen ? "rot_three" : "line3"}`} />
      </div>
    </header>
  )
}
export default Header
